import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { notificationService } from "../services/notification.service";

// Queries whose data may change when an institution sends data to verify.
const AFFECTED_QUERY_KEYS = [
  ["notifications"],
  ["notifications-unread"],
  ["institutional-verification"],
  ["legality-data"],
  ["facility-data"],
  ["program-data"],
];

// Opens a Server-Sent Events connection to the back office while `enabled`.
// The browser reconnects by itself if the connection drops.
export const useNotificationStream = ({ enabled, onNotification }) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!enabled || typeof EventSource === "undefined") return undefined;

    const source = new EventSource(notificationService.streamUrl(), {
      withCredentials: true,
    });

    const handleNotification = (event) => {
      let notification;
      try {
        notification = JSON.parse(event.data);
      } catch {
        return;
      }
      AFFECTED_QUERY_KEYS.forEach((queryKey) =>
        queryClient.invalidateQueries({ queryKey }),
      );
      onNotification?.(notification);
    };

    source.addEventListener("notification", handleNotification);
    return () => {
      source.removeEventListener("notification", handleNotification);
      source.close();
    };
    // onNotification is intentionally left out so the connection is not
    // reopened on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, queryClient]);
};
